import { useEffect } from 'react';

import Grid from '@mui/material/Grid';

import { ensureDefined } from '@e-socna/utils';

import { useContextualizedFields } from '../../../../hooks/useContextualizedFields.hook';

import type { MaterialUsageForm_MaterialUsage } from '../../fragments/material-usage.fragment';

import { Selection } from './Selection';

interface Props {
  readonly formContext?: string;
  readonly id: string;
  readonly setIsUsingMaterials: (isUsing: boolean) => void;
}

export const MaterialsSelectionFormStep = ({
  formContext,
  setIsUsingMaterials,
}: Readonly<Props>) => {
  const fields = useContextualizedFields<
    Readonly<{
      materialUsages: readonly MaterialUsageForm_MaterialUsage[] | undefined;
    }>
  >(
    {
      materialUsages: {
        id: 'material-usages-selection',
        name: 'materialUsages',
      },
    },
    formContext,
  );

  const { materialUsages } = ensureDefined({
    materialUsages: fields.materialUsages.value,
  });

  useEffect(() => {
    setIsUsingMaterials(!!materialUsages.length);
  }, [materialUsages, setIsUsingMaterials]);

  return (
    <Grid container sx={{ height: '100%', display: 'flex', flexGrow: 1 }}>
      <Grid size={12} sx={{ display: 'flex', flexDirection: 'column' }}>
        <Selection
          fieldName={fields.materialUsages.name}
          materialUsages={materialUsages}
        />
      </Grid>
    </Grid>
  );
};
